import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { UpdateUserApi } from "../../api";
import IPConstants from "../../classes/IPConstants";
import IPUtility from "../../classes/IPUtility";
import { KISAUser } from "../../models/KISAUser";
import { alterUserAction } from "./authReducer";
import { toastPopupOpenAction } from "./interactionReducer";
// import axios from "axios";

// import {userListApi} from "../../api";
// import {
//   initializeKisaUser,
//   KISAUser,
//   KISAUserListRequest,
// } from "../../models/KISAUser";

// export const getUserList = createAsyncThunk(
//   "/userList",
//   async (params: KISAUserListRequest) => {
//     try {
//       const requestParams: KISAUserListRequest = {
//         userToken: params.userToken,
//         page: params.page,
//         rowCount: params.rowCount,
//         searchWord: params.searchWord,
//       };
//       return await axios
//         .post(userListApi, requestParams)
//         .then((res) => res.data);
//     } catch (error) {
//       throw new Error("네트워크 에러");
//     }
//   }
// );

// interface userListType {
//   loading: boolean;
//   userList: KISAUser[];
//   error: string;
//   maxPage: number;
//   message: string;
//   participantsUsers: KISAUser[];
//   tableHeader: string[];
//   searchWord: string;
//   page: number;
// }
// const initialState: userListType = {
//   loading: true,
//   userList: [],
//   error: "",
//   maxPage: 0,
//   message: "",
//   participantsUsers: [] as KISAUser[],
//   tableHeader: ["이름", "부서", "이메일", "편집"],
//   searchWord: "",
//   page: 0,
// };

export interface userRequest {
  userToken: string; // 사용자 식별 값
  item: KISAUser; // 프로젝트 ,
  successHandler?: any;
  failHandler?: any;
}

export const updateUser = createAsyncThunk(
  "/updateUser",
  async (params: userRequest, { dispatch }) => {
    try {
      const requestParams: userRequest = {
        userToken: params.userToken,
        item: params.item,
      };
      return await axios
        .post(UpdateUserApi, requestParams)
        .then((res) => res.data)
        .then((data) => {
          if (
            data !== undefined &&
            data.message.indexOf(IPConstants.successMessage) > -1
          ) {
            dispatch(
              toastPopupOpenAction({
                contents: "사용자 정보가 업데이트 되었습니다.",
                severity: "info",
              })
            );
            IPUtility.log(data);
            dispatch(alterUserAction({ item: data.item }));
            if (params.successHandler) params.successHandler();
          } else
            dispatch(
              toastPopupOpenAction({
                contents: "사용자 정보 업데이트에 실패했습니다.",
                severity: "warning",
              })
            );
          return data;
        });
    } catch (error) {
      throw new Error("네트워크 에러");
    }
  }
);

const userListSlice = createSlice({
  name: "userList",
  initialState: "",
  reducers: {
    // addMemberAction: (state, {payload}: PayloadAction<number | null>) => {
    //   if (state.participantsUsers.find((member) => member.uid === payload)) {
    //     return;
    //   } else {
    //     const addMember = state.userList.find(
    //       (member) => member.uid === payload
    //     );
    //     state.participantsUsers = [...state.participantsUsers, addMember!];
    //   }
    // },
    // deleteMemberAction: (state, {payload}: PayloadAction<number>) => {
    //   const deleteMember = state.participantsUsers.filter(
    //     (member) => member.uid !== payload
    //   );
    //   state.participantsUsers = deleteMember;
    // },
    // searchUserAction: (state, {payload}: PayloadAction<any>) => {
    //   if (payload.page === undefined) state.page = 1;
    //   if (payload.inputWord !== undefined) {
    //     state.searchWord = payload.inputWord;
    //     state.page = payload.page;
    //   } else {
    //     return;
    //   }
    // },
  },
  // extraReducers: {
  //   [getUserList.pending.type]: (state) => {
  //     state.loading = true;
  //   },
  //   [getUserList.fulfilled.type]: (state, action) => {
  //     state.loading = false;
  //     state.userList = action.payload.items;
  //     state.maxPage = action.payload.maxPage;
  //     state.message = action.payload.message;
  //   },
  //   [getUserList.rejected.type]: (state, action) => {
  //     state.loading = false;
  //     state.error = action.error.message;
  //   },
  // },
});

// export const {addMemberAction, deleteMemberAction, searchUserAction} =
//   userListSlice.actions;
export default userListSlice.reducer;
